import React, { useMemo } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import classNames from 'classnames';

import FEATURES from '../../../constants/featureToggling';
import { createMockEntitiesArray } from '../../../utils/collectionAdapters';
import { validateLimit } from '../../widgets/utils';

import Skeleton from '../../Skeleton/Skeleton';
import styles from './index.module.css';

const SKELETON_COUNT = 6;

const GameCardsLineListSkeleton = ({ className, config }) => {
  const shouldUseThreeColumnsForGames = useFeature(
    FEATURES.USE_THREE_COLUMNS_FOR_GAMES
  ).on;

  const customLimit = validateLimit(config?.limit) ?? SKELETON_COUNT;

  const items = useMemo(
    () => createMockEntitiesArray(customLimit),
    [customLimit]
  );

  const lines = useMemo(() => {
    if (!config?.lines) return [1];

    return Array.from({ length: Math.abs(config?.lines) }).map((_v, i) => i);
  }, [config?.lines]);

  return (
    <div
      className={classNames(
        styles.component,
        shouldUseThreeColumnsForGames && styles.threeColumn,
        className
      )}
    >
      <div className={styles.header}>
        <Skeleton className={styles.title} />
        <Skeleton className={styles.more} />
      </div>

      {lines.map((index) => (
        <div key={index} className={classNames(styles.list, styles.cardLine)}>
          {items.map((item) => (
            <div key={item.id} className={styles.cardContainer}>
              <Skeleton className={styles.card} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default GameCardsLineListSkeleton;
